import { render, staticRenderFns } from "./AllowanceUpdateModal.vue?vue&type=template&id=06538989&"
import script from "./AllowanceUpdateModal.vue?vue&type=script&lang=js&"
export * from "./AllowanceUpdateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports